import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import OfficeAssistant from "./App";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("页面入口 #root 不存在");
}

createRoot(root).render(
  <StrictMode>
    <OfficeAssistant />
  </StrictMode>,
);
